__turbopack_context__.v({
  "link": "CompanyHeroHeader-module-scss-module__a1_nza__link",
  "logo": "CompanyHeroHeader-module-scss-module__a1_nza__logo",
  "name": "CompanyHeroHeader-module-scss-module__a1_nza__name",
});
